<template>
  <div>
    Unknown Viewer
    <pre>{{ container }}</pre>
    <pre>{{ media }}</pre>
  </div>
</template>
<script>
export default {
  name: 'UnknownViewer',
  emits: [],
  components: {},
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
};
</script>
<style></style>
